import axios from 'axios'
import * as vars from './vars';

// data = {url: String, caption: String, type: VIDEO | PHOTO}
export function submitUserContent(ipedsid, content, jwt) {
    const data = content
    data['ipedsid'] = ipedsid

    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/college/SubmitUserGeneratedContent',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function getUserContent(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/college/GetGeneratedCollegeContentForUser',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}


export function deleteUserContent(imageId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v2/college/DeleteGeneratedCollegeContentForUser',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            imageId: imageId
        }
    })
}

